/**
 * WhiteFyr — Premium visual pass (2026-08-24)
 *
 * IntersectionObserver fallback for the scroll-triggered section reveal
 * defined in assets/whitefyr-premium.css. The primary implementation is
 * CSS-only (`animation-timeline: view()`), which needs no JS at all and
 * degrades safely to "just visible" in unsupported browsers. This file
 * only does anything in browsers that lack that CSS feature, so the two
 * paths never run at once.
 *
 * Also respects prefers-reduced-motion, matching the CSS guard.
 */
(function () {
  if (typeof CSS !== 'undefined' && CSS.supports && CSS.supports('animation-timeline: view()')) {
    return;
  }

  if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    return;
  }

  if (!('IntersectionObserver' in window)) {
    return;
  }

  function init() {
    var sections = document.querySelectorAll('#MainContent > .shopify-section');
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('wf-io-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    sections.forEach(function (section) {
      section.classList.add('wf-io-observed');
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
